import React, { Component } from 'react';

import Anime from 'react-anime';

import SiteLogo from '../pages/images/thumbs/logo.png';

import Link from "gatsby-link";

import { Route, Redirect } from "react-router-dom";
//import { Link, hashHistory } from 'react-router'

class Menu extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            open: this.props.open,
            color: '#fcf652',
        }

        this.menuItems = [
            { id: 0, name: 'Blog', link: '/blog' }, 
            { id: 1, name: 'Home', link: '/' }, 
            { id: 2, name: 'Contact', link: '/contact' }
        ];

        this.colors = ['#fcf652', '#52AFFC' , '#FFA0D8' , '#FF8282' , '#66FC52' ];

    }

    componentWillReceiveProps(props){
        console.log(this.state.open, this.state.color);
        this.setState({open: props.open, color: (props.open) ? this.colors[Math.floor(Math.random()*this.colors.length)] : this.state.color });
        //this.refs.menu.style.display = (props.open) ? 'block' : this.refs.menu.style.display;
    }

    _onMenuClick = () => this.props.handleToggle();

    render(){
        let state = this.state.open;
        let transformOrigin = (this.state.open) ? '50% 100%' : '50% 0';
        let color = this.state.color;

        return (
            <div>
            <Anime easing="easeInOutQuint"
                autoplay={true}
                duration={1000}
                begin={this.props.animeBegin}
                complete={this.props.animeComplete}
                scaleY={(state) ? [0,1] : [1,0]}>
                <div style={{ transformOrigin: transformOrigin, backgroundColor: color}} className="menu-background" />
            </Anime>
            <ul style={{display: 'block'}} className="menu">
                <Anime 
                opacity={(state) ? [0,1] : [1,0]} 
                delay={500}
                autoplay={true}
                >
                    {this.menuItems.map((item, index)=><li className="menu__item" key={index}><Link to={item.link} className="menu__link" onClick={() => this._onMenuClick()} >{item.name}</Link></li>)}
                </Anime>
            </ul>
            </div>
            );
    }

}

class Header extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            open: false,
            animation: 'complete',
            stage: true
        }

    }

    componentDidMounted(){
        this.refs.menu.style.display = 'none';
    }

    shouldComponentUpdate(nextProps, nextState){

        //console.log(this.state, nextProps);
        
        if (nextState.animation == 'begin'){
            /* Если идет анимация компонент не пререрисовываем */
            return false;                            
        } else if (nextState.animation == 'complete' && (this.state.open !== nextState.open)){
            /* Перерисовываем компонент, только если анимация завершилась и изменилось состояние меню. */
            return true; 
        }

        /* Если рассмотрели все случаи перерисовки компонента, то по умолчанию можно не перерисовывать. */

        return false;

    }

    _animeBegin = () => {
            this.refs.menu.style.display = 'block';
            this.setState({animation: 'begin'})
    }

    _animeComplete = () => {
            this.refs.menu.style.display = (this.state.open) ? 'block' : 'none'
            this.setState({animation: 'complete'});
    }


    _handleToggle = () => {

        console.log(this.state.open);

        if (this.state.animation == 'complete'){
            this.setState({open: !this.state.open});
        }

        if (this.state.stage){
            this.setState({stage: false});
        }

    }

    render() {
        return (
            <header role="header">
                <div className="container">
                    <h1>
                        <img src={SiteLogo} width="66" title="Ufon" alt="Ufon" />
                    </h1>
                    <button onClick={this._handleToggle} className={this.state.open ? "menu-button is-active" : "menu-button"} id="menuButton">
                        <span className="burger-icon"></span>
                    </button>
                </div>
                <div ref="menu">
                { (!this.state.stage) ? <Menu handleToggle={this._handleToggle} animeBegin={this._animeBegin} animeComplete={this._animeComplete} open={this.state.open} /> : null}
                </div>
            </header>
        );
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/layouts/Header.js